import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
// import App1 from './App1';
import * as serviceWorker from "./serviceWorker";
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import Hls from "hls.js";

import "./index.css";
import "./design/miscellaneous.css";
var cors = require('cors')


// react-player does not use the hls.js this app bundles. FilePlayer injects a script tag
// for `https://cdn.jsdelivr.net/npm/hls.js@${hlsVersion}/dist/hls.min.js`, and hlsVersion
// defaults to 1.1.4 (react-player/lib/props.js) — a build from November 2021. Nothing here
// overrode it, so every recording played through ReactPlayerHoc was remuxed by 1.1.4 while
// the live class player (pages/broadcast/hls-player.js, a direct `import Hls from 'hls.js'`)
// used the 1.5.1 in package.json. Same stream, two remuxers, and only one of them carries
// the audio-gap fixes that landed after 1.1.4.
//
// The difference is audible rather than theoretical. Transcoded output leaves small gaps at
// segment seams; mp4-remuxer covers them by injecting silent frames, and 1.1.4 predates that
// path being made reliable — which is why a recording that plays cleanly in any current HLS
// player broke up inside this app. See the maxAudioFramesDrift comment in
// pages/broadcast/playRecordings.js, which describes the same failure from the other end.
//
// getSDK checks window[sdkGlobal] before fetching anything, and FilePlayer passes it no
// isLoaded predicate, so publishing the bundled copy here is all it takes: every
// react-player surface in the app — recordings, class resources, digital library,
// marketplace — picks it up, with no CDN round trip and no second version to drift out of
// step with package.json. Set before render so it is in place ahead of the first player
// mount, and guarded so an Hls already on window still wins.
if (typeof window !== "undefined" && !window.Hls) {
  window.Hls = Hls;
}

Sentry.init({
  dsn: "https://ffb5258a54564054a518820655afc5f4@o932470.ingest.sentry.io/5881205",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
